exports.onRouteUpdate = () => {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'gatsby-route-change' });
  }
};
